import React from "react";
import { Link } from "react-router-dom";

export const Access = () => {
  return (
    <div className="exception-body access">
      <img
        src="assets/layout/images/logo-white.svg"
        alt="diamond-layout"
        className="logo"
      />

      <div className="exception-content">
        <div className="exception-title">Yetkisiz Giriş</div>
        <div className="exception-detail">Buraya Girmeye Yetkiniz Yok.</div>
        <Link to="/dashboard">Ana Sayfaya Dön</Link>
      </div>
    </div>
  );
};
